let currencySymbol = '$';
if (window.themeSettings.storeCurrency && Shopify) {
  const { currency: { active } } = Shopify;
  const { storeCurrency } = window.themeSettings;
  const current = storeCurrency.find(({ ISO }) => ISO === active );
  if (current) currencySymbol = current.symbol;
}

const moneyFormat = (amount) => {
  return `${currencySymbol}${(amount / 100).toFixed(2)}`;
}

const fetchCart = async () => {
  try {
    const res = await fetch('/cart.js');
    const data = await res.json();
    if (res.ok) return data;
  } catch (error) {
    console.log(error);
    return null
  }
}

class CartThreshold extends HTMLElement {
    constructor() {
      super();
  
      this.enabledTargets = [];
      this.maxTarget = 0;
  
      this.script = this.querySelector('script');
      this.data = this.script ? JSON.parse(this.script.textContent) : null;
      this.enabled = this.data ? this.data.settings.enabled : null;
      if (!this.data || !this.enabled) return;
  
      const [ freeShipping ] = this.data.targets;
      if (freeShipping.value > 0) {
        this.enabledTargets.push(freeShipping);
      }
  
      if (!this.enabledTargets.length) return;
      this.enabledTargets = this.enabledTargets.sort((a, b) => a.value - b.value);
  
      const allTargets = this.enabledTargets.map(({ value }) => value);
      this.maxTarget = Math.max(...allTargets);
      if (this.maxTarget === 0) return;
  
      this.#renderElements();
      this.#init();
  
      document.addEventListener('cart:updated', (evt) => {
        const { detail: { cart } } = evt;
        this.#calculateShipping(cart);
      });
    }
  
    #convertToCurrency(amount) {
      return Shopify?.currency?.rate ? Math.trunc(Shopify.currency.rate * +amount) : Math.trunc(+amount)
    }
  
    async #init() {
      const cartData = await fetchCart();
      this.#calculateShipping(cartData);
    }
  
    #renderElements() {
      const target= this.#convertToCurrency(this.maxTarget);
      const renderProgressDots = this.enabledTargets.map(({ name, label, value }, index) => {
        return `
        <span
            class="promo-dots promo--${name} promo--${name}-${index}"
            data-target="${value}"
            data-currency-symbol="${currencySymbol}"
            data-label="${label}"
            aria-hidden="true"
            style="--position: ${(value/this.maxTarget) * 100}">
        </span>
        `
      }).join('');
  
      const html = `
        <div class="cart-promotions-wrapper" data-target="${target}" data-currency-symbol="${currencySymbol}">
          <label for="cart-promotions" class="visually-hidden">Cart Promotions</label>
          <progress id="cart-promotions" max="100" value="0" data-target="${target}"></progress>
          <span class="promo-dots promo--value"></span>
          ${renderProgressDots}
          <div class="cart-promotions-total">${currencySymbol}${target}</div>
        </div>
        <div id="cart-promotions-message" class="cart-promotions-message"></div>
      `;
  
      this.innerHTML = html;
    }
  
    #calculateShipping(cartJson) {
      const targets = this.enabledTargets;
      const total = cartJson.total_price && cartJson.total_price > 0 ? cartJson.total_price : cartJson.final_price && cartJson.final_price > 0 ? cartJson.final_price : 0;
      const cartTotal = total > 0 ? total / 100 : 0;
      const progressValue = (cartTotal / this.#convertToCurrency(this.maxTarget)) * 100;
      const container = document.getElementById('cart-promotions');
      let message = '';
  
      if (progressValue >= 100) {
        container.setAttribute('value', 100);
        container.parentElement.setAttribute('value', 100);
      } else {
        container.setAttribute('value', progressValue ? progressValue : 0);
        container.parentElement.setAttribute('value', progressValue ? progressValue : 0);
      }
  
      if (this.querySelector('.promo--value')) {
        this.querySelector('.promo--value').style.setProperty('--position', progressValue > 100 ? 100 : progressValue);
      }
  
      if (!this.maxTarget) {
        message = 'Please enter target amounts in Theme Settings > Cart Promotions'
        return;
      }
  
      if (cartTotal <= 0) {
        message = this.data.settings.default;
      } else {
        for (const [index, target] of targets.entries()) {
          const promoDot = this.querySelector(`.promo--${target.name}-${index}`);
          const remaining = this.#convertToCurrency(target.value) - cartTotal;
  
          if (remaining <= 0) {
            message = `<span>${target.messaging.success.replaceAll('[title]', target.title ?? '')}</span><br/>` ?? '';
            if (promoDot) promoDot.classList.add('active');
          } else {
            message += target.messaging.ongoing.replace('[remaining]', `<strong>${currencySymbol}${remaining ? remaining.toFixed(2) : target.value.toFixed(2)}</strong>`).replaceAll('[title]', target.title ?? '') ?? '';
            if (promoDot) promoDot.classList.remove('active');
            break;
          }
        }
      }
      // Display message
      document.getElementById('cart-promotions-message').innerHTML = message;
    }
}

customElements.define('widget-cart-threshold', CartThreshold);

class CartThresholdTiers extends HTMLElement {
  constructor() {
    super();

    this.enabledTargets = [];
    this.maxTarget = 0;

    this.script = this.querySelector('script');
    this.data = this.script ? JSON.parse(this.script.textContent) : null;
    this.enabled = this.data ? this.data.settings.enabled : null;
    if (!this.data || !this.enabled) return;

    const [ tier1, tier2, tier3 ] = this.data.targets;
    if (tier1.value > 0) {
      this.enabledTargets.push(tier1);
    }
    if (tier2.value > 0) {
      this.enabledTargets.push(tier2);
    }
    if (tier3.value > 0) {
      this.enabledTargets.push(tier3);
    }

    if (!this.enabledTargets.length) return;
    this.enabledTargets = this.enabledTargets.sort((a, b) => a.value - b.value);

    const allTargets = this.enabledTargets.map(({ value }) => value);
    this.maxTarget = Math.max(...allTargets);
    if (this.maxTarget === 0) return;

    this.#renderElements();
    this.#init();

    document.addEventListener('cart:updated', (evt) => {
      const { detail: { cart } } = evt;
      this.#calculateShipping(cart);
    });
  }

  #convertToCurrency(amount) {
    return Shopify?.currency?.rate ? Math.trunc(Shopify.currency.rate * +amount) : Math.trunc(+amount)
  }

  async #init() {
    const cartData = await fetchCart();
    this.#calculateShipping(cartData);
  }

  #renderElements() {
    const target= this.#convertToCurrency(this.maxTarget);
    const renderProgressDots = this.enabledTargets.map(({ name, label, value }, index) => {
      return `
      <span
          class="promo-dots promo--${name} promo--${name}-${index}"
          data-target="${value}"
          data-currency-symbol="${currencySymbol}"
          data-label="${label}"
          aria-hidden="true"
          style="--position: ${(value/this.maxTarget) * 100}">
      </span>
      `
    }).join('');

    const html = `
      <div class="cart-promotions-wrapper" data-target="${target}" data-currency-symbol="${currencySymbol}">
        <label for="cart-promotions" class="visually-hidden">Cart Promotions</label>
        <progress id="cart-promotions-tiers" max="100" value="0" data-target="${target}"></progress>
        <span class="promo-dots promo--value"></span>
        ${renderProgressDots}
        <div class="cart-promotions-total">${currencySymbol}${target}</div>
      </div>
      <div id="cart-promotions-message-tiers" class="cart-promotions-message"></div>
    `;

    this.innerHTML = html;
  }

  #calculateShipping(cartJson) {
    const targets = this.enabledTargets;
    const total = cartJson.total_price && cartJson.total_price > 0 ? cartJson.total_price : cartJson.final_price && cartJson.final_price > 0 ? cartJson.final_price : 0;
    const cartTotal = total > 0 ? total / 100 : 0;
    const progressValue = (cartTotal / this.#convertToCurrency(this.maxTarget)) * 100;
    const container = document.getElementById('cart-promotions-tiers');
    let message = '';

    if (progressValue >= 100) {
      container.setAttribute('value', 100);
      container.parentElement.setAttribute('value', 100);
    } else {
      container.setAttribute('value', progressValue ? progressValue : 0);
      container.parentElement.setAttribute('value', progressValue ? progressValue : 0);
    }

    if (this.querySelector('.promo--value')) {
      this.querySelector('.promo--value').style.setProperty('--position', progressValue > 100 ? 100 : progressValue);
    }

    if (!this.maxTarget) {
      message = 'Please enter target amounts in Theme Settings > Cart Promotions'
      return;
    }

    if (cartTotal <= 0) {
      message = this.data.settings.default;
    } else {
      for (const [index, target] of targets.entries()) {
        const promoDot = this.querySelector(`.promo--${target.name}-${index}`);
        const remaining = this.#convertToCurrency(target.value) - cartTotal;

        if (remaining <= 0) {
          message = `<span>${target.messaging.success.replaceAll('[title]', target.title ?? '')}</span><br/>` ?? '';
          if (promoDot) promoDot.classList.add('active');
        } else {
          message += target.messaging.ongoing.replace('[remaining]', `<strong>${currencySymbol}${remaining ? remaining.toFixed(2) : target.value.toFixed(2)}</strong>`).replaceAll('[title]', target.title ?? '') ?? '';
          if (promoDot) promoDot.classList.remove('active');
          break;
        }
      }
    }
    // Display message
    document.getElementById('cart-promotions-message-tiers').innerHTML = message;
  }
}

customElements.define('widget-cart-threshold-tiered-promotions', CartThresholdTiers);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.display = this.querySelector('[data-time-display]');
    this.block = this.closest('.countdown__block--timer');
    this.year = this.el.dataset.year;
    this.month = this.el.dataset.month;
    this.day = this.el.dataset.day;
    this.hour = this.el.dataset.hour;
    this.minute = this.el.dataset.minute;
    this.daysPlaceholder = this.querySelector('[date-days-placeholder]');
    this.hoursPlaceholder = this.querySelector('[date-hours-placeholder]');
    this.minutesPlaceholder = this.querySelector('[date-minutes-placeholder]');
    this.secondsPlaceholder = this.querySelector('[date-seconds-placeholder]');
    this.messagePlaceholder = this.querySelector('[data-message-placeholder]');
    this.hideTimerOnComplete = this.el.dataset.hideTimer;
    this.completeMessage = this.el.dataset.completeMessage;

    this.timerComplete = false;

    this.init();
  }

  init() {
    setInterval(() => {
      if (!this.timerComplete) {
        this._calculate();
      }
    }, 1000);

  }

  _calculate() {
    // Find time difference and convert to integer
    const timeDifference = +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() - +new Date().getTime();
    // If time difference is greater than 0, calculate remaining time
    if (timeDifference > 0) {
      const intervals = {
        days: Math.floor(timeDifference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((timeDifference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((timeDifference / 1000 / 60) % 60),
        seconds: Math.floor((timeDifference / 1000) % 60),
      };
      if(intervals.days < 10) {
        intervals.days = `0${intervals.days}`;
      }
      if(intervals.hours < 10) {
        intervals.hours = `0${intervals.hours}`;
      }
      if(intervals.minutes < 10) {
        intervals.minutes = `0${intervals.minutes}`;
      }
      if(intervals.seconds < 10) {
        intervals.seconds = `0${intervals.seconds}`;
      }

      this.daysPlaceholder.innerHTML = intervals.days;
      this.hoursPlaceholder.innerHTML = intervals.hours;
      this.minutesPlaceholder.innerHTML = intervals.minutes;
      this.secondsPlaceholder.innerHTML = intervals.seconds;
    } else {
      if (this.completeMessage && this.messagePlaceholder) {
        this.messagePlaceholder.classList.add('countdown__timer-message--visible');
      }

      if (this.hideTimerOnComplete === 'true') {
        this.display.classList.remove('countdown__display--visible');
        this.display.classList.add('countdown__display--hidden');
      }

      if (!this.completeMessage && this.hideTimerOnComplete === 'true') {
        this.block.classList.add('countdown__block--hidden');
      }

      this.timerComplete = true;
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);